import type { Action } from 'redux';
import server from '../../../../main/support/server';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const SearchAndroidAppName = new ReduxAsyncAction<'SEARCH_ANDROID_APP_NAME', string, { androidAppName: string }>(
  'SEARCH_ANDROID_APP_NAME'
);

SearchAndroidAppName.registerRequest(async (packageSlug: string) => {
  const data = await server('google play load', { value: packageSlug }, {});

  const androidAppName = data.text;

  return { androidAppName };
});

export const SEARCH_ANDROID_APP_NAME = SearchAndroidAppName.actionNamespaceConstants;
export const searchAndroidAppName = SearchAndroidAppName.request;

export type SearchAndroidAppNameResponseAction = Action<typeof SEARCH_ANDROID_APP_NAME.response> & {
  data: { androidAppName: string };
};
